function latin1Decode(bytes, start, end) {
  let text = ''
  for (let i = start; i < end; i++) text += String.fromCharCode(bytes[i])
  return text
}

function latin1Encode(text) {
  const out = new Uint8Array(text.length)
  for (let i = 0; i < text.length; i++) out[i] = text.charCodeAt(i) & 0xff
  return out
}

function concatBytes(parts) {
  const length = parts.reduce((sum, part) => sum + part.length, 0)
  const out = new Uint8Array(length)
  let offset = 0
  for (const part of parts) {
    out.set(part, offset)
    offset += part.length
  }
  return out
}

function isWs(byte) {
  return byte === 32 || byte === 10 || byte === 13 || byte === 9 || byte === 12
}

function indexOfAscii(bytes, needle, start) {
  const encoded = latin1Encode(needle)
  const last = bytes.length - encoded.length
  for (let i = start; i <= last; i++) {
    let found = true
    for (let j = 0; j < encoded.length; j++) {
      if (bytes[i + j] !== encoded[j]) {
        found = false
        break
      }
    }
    if (found) return i
  }
  return -1
}

function lineEndAt(bytes, pos) {
  while (pos < bytes.length && bytes[pos] !== 10 && bytes[pos] !== 13) pos++
  return pos
}

function skipLineBreak(bytes, lineEnd) {
  if (bytes[lineEnd] === 13 && bytes[lineEnd + 1] === 10) return lineEnd + 2
  return lineEnd + 1
}

function readStartXref(bytes) {
  const start = Math.max(0, bytes.length - 160)
  const match = latin1Decode(bytes, start, bytes.length).match(/startxref\s+(\d+)/)
  if (!match) throw new Error('startxref missing')
  return Number(match[1])
}

function parseXref(bytes) {
  const start = readStartXref(bytes)
  if (latin1Decode(bytes, start, start + 4) !== 'xref') throw new Error('xref stream')

  let pos = start + 4
  const entries = new Map()
  while (pos < bytes.length) {
    while (isWs(bytes[pos])) pos++
    if (latin1Decode(bytes, pos, pos + 7) === 'trailer') break
    const lineEnd = lineEndAt(bytes, pos)
    const parts = latin1Decode(bytes, pos, lineEnd).trim().split(/\s+/)
    const first = Number(parts[0])
    const count = Number(parts[1])
    pos = skipLineBreak(bytes, lineEnd)
    for (let i = 0; i < count; i++) {
      const entryEnd = lineEndAt(bytes, pos)
      const entry = latin1Decode(bytes, pos, entryEnd).trim().split(/\s+/)
      if (entry[2] === 'n') entries.set(first + i, Number(entry[0]))
      pos = skipLineBreak(bytes, entryEnd)
    }
  }
  return entries
}

function findDictEnd(bytes, start) {
  let depth = 0
  for (let i = start; i < bytes.length - 1; i++) {
    if (bytes[i] === 40) {
      i++
      while (i < bytes.length && bytes[i] !== 41) {
        if (bytes[i] === 92) i += 2
        else i++
      }
      continue
    }
    if (bytes[i] === 60 && bytes[i + 1] === 60) {
      depth++
      i++
      continue
    }
    if (bytes[i] === 62 && bytes[i + 1] === 62) {
      depth--
      i++
      if (depth === 0) return i + 1
    }
  }
  throw new Error('dict end missing')
}

function dictType(dict) {
  if (/\/Type\s*\/Pages\b/.test(dict)) return 'pages'
  if (/\/Type\s*\/Page\b/.test(dict)) return 'page'
  if (/\/Type\s*\/Catalog\b/.test(dict)) return 'catalog'
  return ''
}

function readLength(dict) {
  const match = dict.match(/\/Length\s+(\d+)(?!\d)/)
  if (!match) throw new Error('stream length missing')
  const rest = dict.slice(match.index + match[0].length)
  if (/^\s+\d+\s+R\b/.test(rest)) return { ref: Number(match[1]) }
  return { value: Number(match[1]) }
}

function parseObjects(bytes, xref) {
  const meta = new Map()

  function parseOne(id, stack) {
    if (meta.has(id)) return meta.get(id)
    if (stack.has(id)) throw new Error('object cycle')
    stack.add(id)

    const objToken = indexOfAscii(bytes, 'obj', xref.get(id))
    if (objToken < 0) throw new Error('obj missing')
    let pos = objToken + 3
    while (isWs(bytes[pos])) pos++

    const info = { id, type: '', hasStream: false, plain: false }
    if (bytes[pos] === 60 && bytes[pos + 1] === 60) {
      const dictEnd = findDictEnd(bytes, pos)
      const dict = latin1Decode(bytes, pos, dictEnd)
      info.type = dictType(dict)
      info.dictStart = pos
      info.dictEnd = dictEnd
      let after = dictEnd
      while (isWs(bytes[after])) after++
      if (latin1Decode(bytes, after, after + 6) === 'stream') {
        info.hasStream = true
        const lengthInfo = readLength(dict)
        let length = lengthInfo.value
        if (lengthInfo.ref != null) {
          const lengthObject = parseOne(lengthInfo.ref, stack)
          length = Number(latin1Decode(bytes, lengthObject.bodyStart, lengthObject.bodyEnd).trim())
        }
        if (!Number.isFinite(length)) throw new Error('bad stream length')
        let streamStart = after + 6
        if (bytes[streamStart] === 13 && bytes[streamStart + 1] === 10) streamStart += 2
        else if (bytes[streamStart] === 10 || bytes[streamStart] === 13) streamStart += 1
        info.streamStart = streamStart
        info.streamEnd = streamStart + length
      } else {
        info.bodyStart = pos
        info.bodyEnd = dictEnd
      }
    } else {
      const endObj = indexOfAscii(bytes, 'endobj', pos)
      if (endObj < 0) throw new Error('endobj missing')
      info.plain = true
      info.bodyStart = pos
      info.bodyEnd = endObj
    }

    meta.set(id, info)
    stack.delete(id)
    return info
  }

  xref.forEach((offset, id) => {
    if (id !== 0) parseOne(id, new Set())
  })
  return meta
}

function rewriteRefs(dict, map) {
  return dict.replace(/(\d+)\s+(\d+)\s+R/g, (match, number, generation) => {
    const mapped = map.get(Number(number))
    if (mapped == null) return match
    return mapped + ' ' + generation + ' R'
  })
}

function objectBody(bytes, info, map) {
  if (info.plain) return latin1Encode(rewriteRefs(latin1Decode(bytes, info.bodyStart, info.bodyEnd), map))

  let dict = rewriteRefs(latin1Decode(bytes, info.dictStart, info.dictEnd), map)
  if (info.type === 'page') {
    if (/\/Parent\s+\d+\s+\d+\s+R/.test(dict)) dict = dict.replace(/\/Parent\s+\d+\s+\d+\s+R/, '/Parent 2 0 R')
    else dict = dict.replace(/>>\s*$/, '/Parent 2 0 R >>')
  }
  if (!info.hasStream) return latin1Encode(dict)

  return concatBytes([
    latin1Encode(dict),
    latin1Encode('\nstream\n'),
    bytes.slice(info.streamStart, info.streamEnd),
    latin1Encode('\nendstream'),
  ])
}

export function isPdf(bytes) {
  return bytes && bytes.length > 4 && bytes[0] === 0x25 && bytes[1] === 0x50 && bytes[2] === 0x44 && bytes[3] === 0x46
}

export function mergePdfDocuments(documents) {
  if (!documents.length) throw new Error('no pdfs')
  if (documents.length === 1) return documents[0]

  const pieces = []
  const pageIds = []
  let nextId = 3

  documents.forEach(bytes => {
    const pdf = { bytes, objects: parseObjects(bytes, parseXref(bytes)) }
    const map = new Map()
    pdf.objects.forEach((info, id) => {
      if (info.type === 'catalog' || info.type === 'pages') return
      map.set(id, nextId++)
    })
    pdf.objects.forEach((info, id) => {
      if (info.type === 'catalog' || info.type === 'pages') return
      const newId = map.get(id)
      if (info.type === 'page') pageIds.push(newId)
      pieces.push({ id: newId, body: objectBody(pdf.bytes, info, map) })
    })
  })

  if (!pageIds.length) throw new Error('no pages')

  const size = nextId
  const kids = pageIds.map(id => id + ' 0 R').join(' ')
  const parts = []
  const offsets = new Map()
  let cursor = 0
  const push = (bytes) => {
    parts.push(bytes)
    cursor += bytes.length
  }
  const pushObject = (id, body) => {
    offsets.set(id, cursor)
    push(latin1Encode(id + ' 0 obj\n'))
    push(body)
    push(latin1Encode('\nendobj\n'))
  }

  push(new Uint8Array([0x25, 0x50, 0x44, 0x46, 0x2d, 0x31, 0x2e, 0x34, 0x0a, 0x25, 0xe2, 0xe3, 0xcf, 0xd3, 0x0a]))
  pushObject(1, latin1Encode('<< /Type /Catalog /Pages 2 0 R >>'))
  pushObject(2, latin1Encode('<< /Type /Pages /Count ' + pageIds.length + ' /Kids [' + kids + '] >>'))
  pieces.forEach(piece => pushObject(piece.id, piece.body))

  const xrefStart = cursor
  let xref = 'xref\n0 ' + size + '\n0000000000 65535 f \n'
  for (let i = 1; i < size; i++) {
    const offset = offsets.get(i)
    if (offset == null) throw new Error('missing object ' + i)
    xref += String(offset).padStart(10, '0') + ' 00000 n \n'
  }
  xref += 'trailer\n<< /Size ' + size + ' /Root 1 0 R >>\nstartxref\n' + xrefStart + '\n%%EOF'
  push(latin1Encode(xref))
  return concatBytes(parts)
}

export function buildUebergabescheinRequest(task, items, groupText, driverSign, signImageName) {
  const text = {
    0: { text: String(task.company || '').substring(0, 50), x: '10', y: '40' },
    1: { text: task.street || '', x: '10', y: '50' },
    2: { text: task.zipcode || '', x: '10', y: '55' },
    3: { text: task.city || '', x: '25', y: '55' },
    4: { text: task.pickup_date || '', x: '80', y: '80' },
    5: { text: 'Übergabeschein -Nr.: ' + task.id, x: '10', y: '23' },
    6: { text: groupText || '', x: '135', y: '77' },
    7: { text: task.rest_before == null ? '' : String(task.rest_before), x: '80', y: '187' },
    8: { text: task.document_no || '', x: '10', y: '212' },
    9: { text: '', x: '10', y: '245' },
    10: { text: 'gez. ' + (driverSign || ''), x: '150', y: '245' },
    11: { text: '', x: '0', y: '5' },
    12: { text: '', x: '0', y: '5' },
    13: { text: '', x: '0', y: '5' },
    14: { text: '', x: '0', y: '5' },
    15: { text: '', x: '0', y: '5' },
  }

  let y = 110
  for (let i = 0; i < items.length; i++) {
    const item = items[i]
    const wasteCode = item.wasteno || '160103'
    text[11 + i] = {
      text: item.order_qty + '                                        ' + item.pickup_qty + '                              ' + item.article_name + '                     ' + wasteCode,
      x: '10',
      y: String(y),
    }
    y += 10
  }

  return {
    param: {
      vorlage_name: 'uebergabeschein.png',
      pdf_autor: 'Hüska GmbH',
      pdf_name: 'temp.pdf',
      pdf_title: 'Übergabeschein',
      pdf_subject: '',
      pdf_name_crypt: '1234.pdf',
    },
    data: {
      text,
      image: {
        0: {
          name: signImageName || '',
          x: '10',
          y: '225',
          w: '40',
          h: '25',
        },
      },
    },
  }
}
